"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const e = (t) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M21.984 8.78a5.9 5.9 0 0 0-.56-2.29c-.34-.72-.83-1.36-1.431-1.89A6.08 6.08 0 0 0 16.19 3a6 6 0 0 0-2.311.6c-.72.35-1.349 1.06-1.879 1.65-.53-.6-1.183-1.3-1.904-1.65A6.2 6.2 0 0 0 7.785 3a5.9 5.9 0 0 0-3.513 1.35 6.1 6.1 0 0 0-1.59 1.95 5.8 5.8 0 0 0-.651 2.41c-.09.86.02 1.73.29 2.55.28.82.73 1.57 1.33 2.21l7.786 7.33c.15.13.35.2.55.2s.4-.07.55-.2l7.826-7.39c.57-.62 1.01-1.36 1.29-2.15.281-.79.391-1.63.331-2.47z"
      }
    )
  }
), a = l(e);
export {
  a as HeartFilled,
  a as default
};
